import React, { useEffect, useState } from 'react';
import { loadStripe } from "@stripe/stripe-js"
import { postJson } from '../config/frendApi';

const stripe_public_key = process.env.REACT_APP_IS_PROD === 'true' ? process.env.REACT_APP_STRIPE_LIVE_PUBLIC_KEY : process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY;

const getPlans = async () => {
  const { price_plans } = await postJson('/frend-get-stripe-pricings', {});
  const plan = price_plans || [];

  return {
    "monthly": plan[1],
    "yearly": plan[0]
  }
}

function SubscriptionPage() {
  const [plans, setPlans] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    async function loadPlans() {
      try {
        const loadedPlans = await getPlans();
        if (!loadedPlans.monthly || !loadedPlans.yearly) {
          throw new Error('Stripe plan pricing is unavailable right now.');
        }

        if (isMounted) {
          setPlans(loadedPlans);
        }
      } catch (loadError) {
        if (isMounted) {
          setError(loadError.message || 'Unable to load premium plans.');
        }
      }
    }

    loadPlans();

    return () => {
      isMounted = false;
    };
  }, []);

  async function onCheckout(e) {
    e.target.disabled = true
    const interval = e.target.id;
    const { session, membership_id } = JSON.parse(localStorage.getItem("cookie"))
    if (!session) {
      console.error("ERROR: No user session.")
      e.target.disabled = false;
      return;
    }

    const payload = {
      "priceId": plans[interval].id, 
      "success_url": `${window.location.origin}/purchase-success`,
      "cancel_url": `${window.location.origin}/`,
      "userId": session.user.id,
      "email": session.user.email,
      "membershipId" : membership_id
    }

    try {
      const session_id = await postJson('/frend-get-stripe-session', payload);
      const stripe = await loadStripe(stripe_public_key);
      await stripe.redirectToCheckout({sessionId: session_id})
    } catch (checkoutError) {
      setError(checkoutError.message || 'Unable to start checkout right now.');
      e.target.disabled = false;
    }
  }

  if (error) {
    return (
      <div className="subscription-page flex flex-col items-center justify-center h-screen px-6 text-center">
        <h2 className="text-2xl font-semibold mb-4">Premium is temporarily unavailable</h2>
        <p className="text-gray-300 max-w-xl">{error}</p>
      </div>
    );
  }

  if (!plans) {
    return (
      <div className="subscription-page flex flex-col items-center justify-center h-screen">
        <p className="text-lg text-gray-300">Loading plans...</p>
      </div>
    );
  }

  return (
    <div className="subscription-page flex flex-col items-center justify-center h-screen">

      <h2 className="text-2xl font-semibold mb-4">Choose your Plan, cancel anytime.</h2>

      <div className="subscription-options flex justify-center">

        <div className="option bg-gray-100 border border-gray-300 rounded-lg p-6 m-4 text-center w-100">
          <h3 className="text-xl font-semibold mb-2">{plans.monthly.name}</h3> 
          <h4><span className="text-xl font-semibold mb-2">${plans.monthly.price} </span><s>$25.99</s><span className="font-semibold mb-2">/ month</span> </h4>
          <p className="text-gray-600 mb-4">(50% off regular price of $25.99/month)</p>
          <p className="text-gray-600 mb-4">Monthly payment billed as ${plans.monthly.price}</p>

          <button id="monthly" className="bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 rounded" onClick={onCheckout}>
            Select
          </button>
        </div>

        <div className="option bg-gray-100 border border-gray-300 rounded-lg p-6 m-4 text-center w-100">
          <h3 className="text-xl font-semibold mb-2">{plans.yearly.name}</h3> 
          <h4><span className="text-xl font-semibold mb-2">$5.99 </span><s>$25.99</s><span className="font-semibold mb-2">/ month</span> </h4>
          <p className="text-gray-600 mb-4">(75% off regular price of $25.99/month)</p>
          <p className="text-gray-600 mb-4">Annual payment billed as ${plans.yearly.price}</p>
          <button id="yearly" className="bg-green-700 hover:bg-green-800 text-white font-semibold py-2 px-4 rounded" onClick={onCheckout}>
            Select
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionPage;
